import React, { useState } from 'react'
import DateNcity from '../../components/Filters/DateNcity'
import { useAgents } from './agentApis'
import axios from 'axios'
import { baseURL, baseURLWithoutApi } from "../../baseUrl";


export default function RealEstateConsultants() {
    const allAgentsResult = useAgents((state) => state.allAgentsResult)
    const allAgentsPagination = useAgents((state) => state.allAgentsPagination)
    const [isLoading, setIsLoading] = useState(false);
    const test = (mobileNumber) => {
        console.log('TEST OK', mobileNumber);

    }
    const sendSms = async (mobileNumber, event) => {
        // setIsLoading(true);
        event.target.disabled = true;
        try {
            const response = await axios.post(`${baseURL}/RealEstateAgent/ResendSms`, {
                mobile: mobileNumber
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            });
            // setIsLoading(false)
            event.target.disabled = false;

            const newElement = document.createElement('span')
            newElement.style.marginRight = '10px';
            if (response.data) {
                newElement.textContent = "ارسال شد"
                newElement.style.color = 'green';
            } else {
                newElement.textContent = "ارسال ناموفق"
                newElement.style.color = 'red';
            }
            event.target.parentNode.appendChild(newElement)
        } catch (error) {
            console.error("Error checking agent exists:", error);
            const newElement = document.createElement('span')
            newElement.style.marginRight = '10px';
            newElement.style.color = 'red';
            newElement.textContent = "ارسال ناموفق"
            event.target.parentNode.appendChild(newElement)
            event.target.disabled = false;
            return false;
        }
    }




    const [activeKeys, setActiveKeys] = useState([""]);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [selectedAgentID, setSelectedAgentID] = useState(null);
    //   const allCitiesCollapse = [
    //     {
    //         key: '1',
    //         label: ' استان',
    //         children: (
    //             <div>
    //                 {cities.length > 0 ? (
    //                     <Radio.Group
    //                         onChange={handleCityChange}
    //                         value={selectedCity}
    //                         className="flex flex-col"
    //                     >
    //                         {cities.map((city) => (
    //                             <Radio key={city.id} value={city.id}>
    //                                 {city.locName}
    //                             </Radio>
    //                         ))}
    //                     </Radio.Group>
    //                 ) : (
    //                     <p className="text-gray-500">هیچ استانی یافت نشد است</p>
    //                 )}
    //             </div>
    //         ),
    //     },
    // ];
    // const allProvinsesCollapse = [
    //     {
    //         key: '2',
    //         label: ' شهر',
    //         children: (
    //             <div>
    //                 {cityByParentId.length > 0 ? (
    //                     <Radio.Group
    //                         onChange={handleProvinceChange}
    //                         value={selectedProvince}
    //                         className="flex flex-col"
    //                     >
    //                         {cityByParentId.map((city) => (
    //                             <Radio key={city.id} value={city.id}>
    //                                 {city.locName}
    //                             </Radio>
    //                         ))}
    //                     </Radio.Group>
    //                 ) : (
    //                     <p className="text-gray-500">هیچ شهری یافت نشد است</p>
    //                 )}
    //             </div>
    //         ),
    //     },
    // ];
    // const districtsCollapse = [
    //     {
    //         key: '3',
    //         label: ' محله',
    //         children: (
    //             <div className='max-h-[230px] overflow-scroll'>
    //                 {parishByParentId.length > 0 ? (
    //                     <Radio.Group
    //                         onChange={handleDistrictChange}
    //                         value={selectedParish}
    //                         className="flex flex-col"
    //                     >
    //                         {parishByParentId.map((city) => (
    //                             <Radio key={city.id} value={city.id}>
    //                                 {city.locName}
    //                             </Radio>
    //                         ))}
    //                     </Radio.Group>
    //                 ) : (
    //                     <p className="text-gray-500">هیچ محله یافت نشد است</p>
    //                 )}
    //             </div>
    //         ),
    //     },
    // ];
    const openEditAgentModalHandler = (agent) => {
        setSelectedAgent(agent)
    }
    const deleteAgentHandler = async (agent) => {


        // await deleteAgent(ID)
        setSelectedAgentID(agent?.id)
        // setSelectedAgent(agent)
    }
    const onCollapseChange = (keys) => {
        setActiveKeys(keys);
    };
    const markTheRow = (e) => {
        e.target.parentNode.parentNode.classList.add('bg-yellow-300')
    }
    return (
        <div className='mb-[50px]'>
            <p className='text-center text-[20px] font-bold mb-4'>
                مشاورین املاک
                <br />
                <span className='text-sm text-gray-400 font-normal'>
                    تعداد کل:  {allAgentsPagination?.total}
                </span>
            </p>
            <DateNcity isInRealEStateConsultants={true} selectedAgent={selectedAgent} selectedAgentID={selectedAgentID} />
            <div className='rounded-xl border border-gray-300 w-full mt-4 overflow-hidden'>
                <table class="table-auto border-collapse w-full ">
                    <thead className='rounded-xl'>
                        <tr className='bg-[#B9B9B9] '>
                            <th class="border border-gray-300 p-2">ردیف  </th>
                            <th class="border border-gray-300 p-2">نام  </th>
                            <th class="border border-gray-300 p-2">   نام خانوادگی</th>
                            <th class="border border-gray-300 p-2"> شماره همراه</th>
                            <th class="border border-gray-300 p-2">واتساپ  </th>
                            <th class="border border-gray-300 p-2"> استان / شهر/منطقه</th>
                            {/*  <th class="border border-gray-300 p-2">  تاریخ درج در سیستم</th>
              <th class="border border-gray-300 p-2">    ورود به پلاک</th>
              <th class="border border-gray-300 p-2">    تعداد اشتراک ها   </th>
              <th class="border border-gray-300 p-2">    تعداد فایل ها </th> */}

                            <th class="border border-gray-300 p-2">         </th>
                        </tr>
                    </thead>
                    <tbody>
                        {allAgentsResult?.map((agent, index) =>
                        (

                            <tr key={index}>
                                <td class="border border-gray-300 p-2">
                                    {((allAgentsPagination?.currentPage - 1) * allAgentsPagination?.perPage) + index + 1 }
                                </td>
                                <td class="border border-gray-300 p-2">{agent?.firstName}</td>
                                <td class="border border-gray-300 p-2" >{agent?.lastName}</td>
                                <td class="border border-gray-300 p-2" >
                                    {agent?.mobile}
                                    <button
                                        className='rounded text-white bg-blue-300 hover:bg-blue-600 px-2 mr-3 border-blue-500'
                                        onClick={(e) => sendSms(agent?.mobile, e)}
                                    >
                                        {isLoading ? 'در حال ارسال...' : 'ارسال مجدد پیامک'}
                                    </button>
                                </td>
                                {/* <td class="border border-gray-300 p-2"><a href={`https://wa.me/${agent.mobile}`} target='_blank'>{agent.mobile}</a></td> */}
                                <td class="border border-gray-300 p-2">
                                    {agent?.mobile && (
                                        <a href={`https://wa.me/+98${agent?.mobile.replace(/\D/g, '')}`} target='_blank' onClick={markTheRow}>{agent.mobile}</a>
                                    )}
                                </td>
                                <td class="border border-gray-300 p-2" >
                                    {agent?.state?.locName}
                                    {agent?.city?.locName && ` / ${agent.city.locName}`}
                                    {agent?.area?.locName && ` / ${agent.area.locName}`}
                                </td>
                                {/* <td class="border border-gray-300 p-2" >Row 1, Col 2 & 3</td>
                <td class="border border-gray-300 p-2" >Row 1, Col 2 & 3</td>
                <td class="border border-gray-300 p-2" >Row 1, Col 2 & 3</td>

                <td class="border border-gray-300 p-2" >Row 1, Col 2 & 3</td> */}
                                <td class="border border-gray-300 p-2 flex justify-between" >
                                    <img
                                        src='/icons/edit-02.svg'
                                        alt='edit icon'
                                        className='cursor-pointer'
                                        onClick={() => openEditAgentModalHandler(agent)}
                                    />
                                    <img src='/icons/trash-02.svg'
                                        alt='trash icon'
                                        className='cursor-pointer'
                                        // onClick={() => deleteAgentHandler(agent?.id)}
                                        onClick={() => deleteAgentHandler(agent)}
                                    />

                                </td>
                            </tr>

                        )
                        )}


                        {/* <tr>
              <td class="border border-gray-300 p-2">Row 1, Col 1</td>
              <td class="border border-gray-300 p-2" >Row 1, Col 2 & 3</td>
              <td class="border border-gray-300 p-2" >Row 1, Col 2 & 3</td>
              <td class="border border-gray-300 p-2" >Row 1, Col 2 & 3</td>
              <td class="border border-gray-300 p-2" >Row 1, Col 2 & 3</td>
              <td class="border border-gray-300 p-2" >Row 1, Col 2 & 3</td>
              <td class="border border-gray-300 p-2" >Row 1, Col 2 & 3</td>

              <td class="border border-gray-300 p-2" >Row 1, Col 2 & 3</td>
              <td class="border border-gray-300 p-2 flex justify-between" >
                <img src='/icons/edit-02.svg' alt='edit icon' />
                <img src='/icons/trash-02.svg' alt='trash icon' />

              </td>
            </tr> */}

                    </tbody>
                </table>


                <>

                    {/* <Modal
            title=" اطلاعات کاربر"
            open={isEditModalVisible}
            onOk={() => {
              setIsEditModalVisible(false)

            }}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
            closeIcon={true}
            maskClosable={true}
            onCancel={() => setIsEditModalVisible(false)}>
            <Formik
              initialValues={{
                firstName: "", lastName: "", phoneNumber: ""
              }}
              validate={values => {
                const errors = {};
                if (!values.firstName) {
                  errors.firstName = '   نام را وارد کنید ';
                } else
                  if (!values.lastName) {
                    errors.lastName = '   نام خانوادگی را وارد کنید  ';
                  } else
                    if (!values.phoneNumber) {
                      errors.phoneNumber = '    شماره تماس را وارد کنید ';
                    }

                return errors;
              }}

              onSubmit={async (values, { resetForm }) => {
                setIsEditModalVisible(false)
                try {
                  const response = await editRealStateAgent(
                    0,
                    values.phoneNumber,
                    values.firstName,
                    values.lastName,
                    "",
                    0,
                    selectedCity,
                    selectedProvince,
                    selectedParish
                  );

                  if (response && response.success) {
                    console.log("API call successful");
                    resetForm(); 
                    setSelectedCity(null);
                    setSelectedProvince(null);
                    setSelectedParish(null);
                    setIsEditModalVisible(false); 
                  } else {
                    console.error("API call failed", response.message);
                  }
                } catch (error) {
                  console.error("Error during API call", error);
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <Form onSubmit={handleSubmit} className=' gap-4 mt-8'>
                  <div className='grid grid-cols-3 gap-4 mb-5'>
                    <div className='flex flex-col gap-1 items-start '>
                      <label htmlFor="firstName" className='font-bold'>*نام  </label>
                      <Field type="text" name="firstName" id="firstName" className='w-full border-2  bg-[#F4F4F4] rounded-lg  px-2 py-1 outline-none ' />
                      <ErrorMessage name="firstName">{msg => <div className='text-[11px]   pr-2'>{msg}</div>}</ErrorMessage>
                    </div>
                    <div className='flex flex-col gap-1 items-start'>
                      <label htmlFor="lastName" className='font-bold'>*نام خانوادگی   </label>
                      <Field type="text" name="lastName" id="lastName" className='w-full border-2  px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' />
                      <ErrorMessage name="lastName">{msg => <div className='text-[11px] pr-2'>{msg}</div>}</ErrorMessage>
                    </div>
                    <div className='flex flex-col gap-1 items-start'>
                      <label htmlFor="phoneNumber" className='font-bold'>    *شماره تماس </label>
                      <Field type="text" name="phoneNumber" id="phoneNumber" className='w-full border-2    px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' />
                      <ErrorMessage name="phoneNumber">{msg => <div className='text-[11px]  pr-2'>{msg}</div>}</ErrorMessage>
                    </div>
                  </div>


                  <div className='grid grid-cols-3 gap-4'>
                    <Collapse accordion
                      items={allCitiesCollapse}
                      activeKey={activeKeys} onChange={onCollapseChange} />
                    <Collapse accordion
                      items={allProvinsesCollapse}
                      activeKey={activeKeys} onChange={onCollapseChange} />
                    <Collapse accordion
                      items={districtsCollapse}
                      activeKey={activeKeys} onChange={onCollapseChange} />


                  </div>
                  <div className='bg-[#227934] text-white flex items-center justify-center  w-full mx-auto max-w-[118px] mt-5 rounded-xl'>
                    <button className='  py-2  font-bold ' onClick={handleSubmit} type='submit'
                   
                    >
                      ثبت
                    </button>
                  </div>
                </Form>
              )}
            </Formik>


          </Modal> */}






                </>




            </div>



        </div>
    )
}
